module.exports = __webpack_public_path__ + "static/cover_photo-989c3d22ed416b6aa06e5d3571a22f19.png";